import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//impoertacion componentes

function CreaTemaPropuesto(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postComentarios, setPostComentarios] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/AgregarRespuestasFicha",
      data: {
        SolicitudId: props.idSolicitud,
        pregunta: "1",
        respuesta: postComentarios,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Agregado!");
        closeModal();
      })
      .catch((error) => {
        console.log(error);
        alert("No dispoblie " + error);
      });
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Agregar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Fecha"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Nuevo Tema Propuesto a Evaluar
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="comentarios"
                            onChange={(e) => setPostComentarios(e.target.value)}
                          />
                        </div>
                      </div>

                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaTemaPropuesto;
